{
  "Accessibility menu": "Menú d'accessibilitat",
  "Close": "Tancar",
  "Content adjustments": "Ajustos de contingut",
  "Navigation adjustments": "Ajustos de navegació",
  "Align Left": "Alinea a l'esquerra",
  "Adjust Font Size": "Ajustar la mida de la font",
  "Highlight Title": "Destacar títol",
  "Highlight Links": "Destacar enllaços",
  "Readable Font": "Font llegible",
  "Colour adjustments": "Ajustos de color",
  "Dark Contrast": "Contrast fosc",
  "Light Contrast": "Contrast clar",
  "High Contrast": "Alt contrast",
  "High Saturation": "Alta saturació",
  "Low Saturation": "Baixa saturació",
  "Monochrome": "Monocrom",
  "Tools": "Eines",
  "Reading Guide": "Guia de lectura",
  "Big Cursor": "Cursor gran",
  "Increase Font Size": "Augmentar mida de la font",
  "Decrease Font Size": "Reduir mida de la font",
  "Letter Spacing": "Espaiat entre lletres",
  "Line Height": "Alçada de línia",
  "Font Weight": "Gruix de la font",
  "Dyslexia Font": "Font per a dislèxia",
  "Language": "Idioma",
  "Accessibility widget": "Obrir menú d'accessibilitat",
  "Accessibility Profiles": "Perfils d'accessibilitat",
  "Cognitive Disability": "Discapacitat cognitiva",
  "Seizure Safe": "Segur per a epilèpsia",
  "Accessibility statement": "Declaració d'accessibilitat",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "Aturar animacions",
  "Reset all settings": "Restablir configuració",
  "Shortcut:": "Shortcut:"
}
